import { render, staticRenderFns } from "./CustomersDropdown.vue?vue&type=template&id=01e78778&scoped=true"
import script from "./CustomersDropdown.vue?vue&type=script&lang=js"
export * from "./CustomersDropdown.vue?vue&type=script&lang=js"
import style0 from "./CustomersDropdown.vue?vue&type=style&index=0&id=01e78778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e78778",
  null
  
)

export default component.exports